<template>
  <div>
    <div class="row mx-md-n2">
      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Company Name"
          :invalid-feedback="errors.company_name ? errors.company_name[0] : ''"
          :state="errors.company_name ? false : null"
        >
          <b-form-input
            name="company_name" type="text"
            trim
            v-model="company.company_name"
            :state="errors.company_name ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="LinkedIn Profile or Website"
          :invalid-feedback="errors.company_url ? errors.company_url[0] : ''"
          :state="errors.company_url ? false : null"
        >
          <b-form-input
            name="company_url" type="text"
            trim
            v-model="company.company_url"
            :state="errors.company_url ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row mx-md-n2">
      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Your Role"
          :invalid-feedback="errors.company_role ? errors.company_role[0] : ''"
          :state="errors.company_role ? false : null"
        >
          <b-form-input
            name="company_role" type="text"
            trim
            v-model="company.company_role"
            :state="errors.company_role ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>

      <div class="col-sm-6 px-md-2">
        <b-form-group
          label="Company's Description"
          :invalid-feedback="errors.company_description ? errors.company_description[0] : ''"
          :state="errors.company_description ? false : null"
        >
          <b-form-input
            name="company_description" type="text"
            trim
            v-model="company.company_description"
            :state="errors.company_description ? false : null"
            :disabled="loading"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="Your Experience">
          <b-form-radio-group
            name="experience" required
            v-model="company.experience"
            :options="experience_options"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="Your Areas of Expertise">
          <b-form-checkbox-group
            name="expertise"
            v-model="company.expertise"
            :options="expertise_options"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="Company's Areas of Needs">
          <b-form-checkbox-group
            name="company_needs"
            v-model="company.company_needs"
            :options="needs_options"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInfoForm',
  props: {
    data: Object,
    errors: Object,
    loading: Boolean
  },
  data () {
    return {
      company: {},
      experience_options: [
        { text: '< 1 year', value: 'lt_1' },
        { text: '1-5 years', value: '1_5' },
        { text: '5-10 years', value: '5_10' },
        { text: '10-20 years', value: '10_20' },
        { text: '20+ years', value: '20p' }
      ],
      expertise_options: [
        { text: 'Finance - Accounting, Tax, Finance', value: '1' },
        { text: 'Legal', value: '2' },
        { text: 'HR', value: '3' },
        { text: 'Strategy - Strategy, Planning, Capital', value: '4' },
        { text: 'Ops - Operations, Product Development, Manufacturing', value: '5' },
        { text: 'Technology', value: '6' },
        { text: 'Mktg/Sales - Marketing, Public Relations, Sales, Customer Relations', value: '7' },
        { text: 'Buy/Sell - Buying and Selling Business', value: '8' },
        { text: 'Franchising', value: '9' },
        { text: 'Intl - International Sales & Procurement', value: '10' },
        { text: 'Govt - Government Regulations & Contracting', value: '11' },
      ],
      needs_options: [
        { text: 'Finance - Accounting, Tax, Finance', value: '1' },
        { text: 'Legal', value: '2' },
        { text: 'HR', value: '3' },
        { text: 'Strategy - Strategy, Planning, Capital', value: '4' },
        { text: 'Ops - Operations, Product Development, Manufacturing', value: '5' },
        { text: 'Technology', value: '6' },
        { text: 'Mktg/Sales - Marketing, Public Relations, Sales, Customer Relations', value: '7' },
        { text: 'Buy/Sell - Buying and Selling Business', value: '8' },
        { text: 'Franchising', value: '9' },
        { text: 'Intl - International Sales & Procurement', value: '10' },
        { text: 'Govt - Government Regulations & Contracting', value: '11' },
      ],
    }
  },
  mounted () {
    this.company = Object.assign({}, this.data)

    this.$skillsService.getSkillsAsValues(false)
      .then((skills) => {
        this.expertise_options = skills
        this.needs_options = skills
      })
  }
}
</script>
